import {
  Box,
  Button,
  DialogActions,
  Stack,
  styled,
  Typography
} from '@mui/material';
import { format } from 'date-fns';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import IconSuccess from '../../assets/icon-success.svg';
import FormatCurrency from '../../components/FormatNumber/FormatCurrency';
import DefaultModal from '../../components/Modals/DefaultModal';
import { Project } from '../../models/project';
import { CREATE_PROJECT, PROJECTS } from '../../router/constants';
import { textEllipsis } from '../../constants';

interface ModalProps {
  data: Project | null;
  open: boolean;
  editing?: boolean;
  resetForm: () => void;
  setOpen: (e: boolean) => void;
}
const BoldText = styled(Typography)(({ theme }) => ({
  fontWeight: 'bold',
  color: theme.palette.grey['900']
}));

const SuccessProjectModal = (props: ModalProps): JSX.Element => {
  const navigate = useNavigate();
  const { open, editing, data, resetForm } = props;

  return (
    <DefaultModal open={open}>
      <Box sx={{ px: 6 }}>
        <Box textAlign="center" mb={3}>
          <img src={IconSuccess} alt="success" />
        </Box>
        <Typography variant="h3" textAlign="center" color="grey.900">
          Success!
        </Typography>
        <Typography variant="h5" textAlign="center" color="grey.900">
          {editing
            ? 'The project has been updated'
            : 'A new project has been created'}
        </Typography>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            my: 3
          }}
          gap={3}
        >
          <Stack spacing={1} sx={{ flexShrink: 0 }}>
            <BoldText>Title:</BoldText>
            <BoldText>Category:</BoldText>
            <BoldText>Project Length:</BoldText>
            <BoldText>Location:</BoldText>
            <BoldText>Assigned to:</BoldText>
            <BoldText>Project Budget:</BoldText>
            <BoldText>Payment Type:</BoldText>
            {data?.pricePerHour && <BoldText>Hourly Rate:</BoldText>}
          </Stack>
          <Stack spacing={1}>
            <Typography>{data?.projectTitle}</Typography>
            <Typography>{data?.category ? data?.category : 'None'}</Typography>
            <Typography>
              {data?.startDate &&
                data?.endDate &&
                format(new Date(data?.startDate), 'MMM do') +
                  ' - ' +
                  format(new Date(data?.endDate), 'MMM do')}
              {data?.startDate == null &&
                data?.endDate == null &&
                'Not specified'}
            </Typography>
            <Typography sx={{ ...textEllipsis, WebkitLineClamp: 1 }}>
              {data?.address ? data?.address : 'Virtual'}
            </Typography>
            <Typography>
              {data?.talent?.firstName + ' ' + data?.talent?.lastName}
            </Typography>
            <Typography>
              {data?.budget ? <FormatCurrency value={data?.budget} /> : 'Open'}
            </Typography>
            <Typography>
              {data?.paymentType === 'FLAT_FEE' ? 'Flat Fee' : 'Hourly Rate'}
            </Typography>
            {data?.pricePerHour && (
              <Typography>
                <FormatCurrency value={data?.pricePerHour} />
                /hour
              </Typography>
            )}
          </Stack>
        </Box>
      </Box>

      <DialogActions sx={{ justifyContent: 'center', p: 3 }}>
        <Button
          variant="outlined"
          onClick={() => navigate(PROJECTS)}
          sx={{ mr: 4 }}
        >
          View All Projects
        </Button>
        <Button
          onClick={() => {
            resetForm();
            navigate(`${CREATE_PROJECT}`);
            props.setOpen(false);
          }}
        >
          Create Another Project
        </Button>
      </DialogActions>
    </DefaultModal>
  );
};

export default SuccessProjectModal;
